module.exports = __webpack_public_path__ + "static/img/v20DetailImg.912b7f6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/v20DetailImg.png
// module id = CgsQ
// module chunks = 1